import { render, staticRenderFns } from "./MyTitle.vue?vue&type=template&id=18a048a0&scoped=true&"
import script from "./MyTitle.vue?vue&type=script&lang=js&"
export * from "./MyTitle.vue?vue&type=script&lang=js&"
import style0 from "./MyTitle.vue?vue&type=style&index=0&id=18a048a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a048a0",
  null
  
)

export default component.exports